// extracted by mini-css-extract-plugin
export default {"wrapper":"EmptyState_wrapper__PEBNF","descr":"EmptyState_descr__6HNfr","bookingList":"EmptyState_bookingList__4JrWW"};